import React from "react"
import atomize from "@quarkly/atomize"
import ProtectedEmail from "./ProtectedEmail"

const TermsAndConditions = ({ lang = "en", ...props }) => {
  if (lang === "ja") {
    return (
      <div
        className="legal-document"
        {...props}
        style={{
          maxWidth: 800,
          margin: "auto",
        }}
      >
        <p className="title">
          <strong>利用規約</strong>
        </p>

        <p className="subtitle">
          <strong>最終更新日：2026年6月4日</strong>
        </p>

        <p className="body_text">
          本利用規約（以下「本規約」）は、Atelier
          α（以下「当スタジオ」または「当方」）が提供するウェブサイトおよびサービス（以下「本サービス」）の利用条件を定めるものです。本サービスにアクセスし利用することで、お客様は本規約に同意したものとみなされます。本規約に同意いただけない場合は、直ちに本サービスの使用を中止してください。
        </p>

        <p className="heading_1">
          <strong>1. 提供するサービス</strong>
        </p>
        <p className="body_text">
          当スタジオは、脳波測定（EEG）および視線計測技術を用いた空間診断、空間最適化設計提案、ワークショップの企画運営、ならびにこれらに関連するコンサルティングサービスを提供しています。
        </p>

        <p className="heading_1">
          <strong>2. 知的財産権</strong>
        </p>
        <p className="body_text">
          本サービスに含まれるすべてのコンテンツ（テキスト、グラフィック、ロゴ、デザイン、ソースコード、独自の脳波分析アルゴリズム、および「身体的注意」設計フレームワークを含みますがこれらに限定されません）は、当スタジオまたはそのライセンサーに帰属し、著作権法およびその他の知的財産権法によって保護されています。当方の書面による事前の許可なく、複製、改変、配布、または商業目的で利用することは禁止されています。
        </p>

        <p className="heading_1">
          <strong>3. クライアントの協力と承諾</strong>
        </p>
        <p className="body_text">
          脳波測定を含む空間診断およびコンサルティングの実施にあたり、お客様には必要な情報のご提供および測定時のご協力をお願いする場合があります。提供された測定データは、個人が特定されない形で、学術研究や設計アルゴリズムの向上のために活用される場合があります。
        </p>

        <p className="heading_1">
          <strong>4. 禁止事項</strong>
        </p>
        <p className="body_text">
          本サービスの利用にあたり、お客様は以下の行為を行ってはなりません。
        </p>
        <ul>
          <li className="body_text">法令または公序良俗に反する行為</li>
          <li className="body_text">
            当スタジオまたは第三者の知的財産権、プライバシー、その他の権利を侵害する行為
          </li>
          <li className="body_text">
            スクレイピング等により当サービスからデータを自動で取得する行為
          </li>
          <li className="body_text">
            本サービスの運営を妨害する行為、または当方のサーバーに過度な負荷をかける行為
          </li>
        </ul>

        <p className="heading_1">
          <strong>5. 免責事項</strong>
        </p>
        <p className="body_text">
          当スタジオが提供する脳波測定結果および空間設計の提案は、個人の生理的・心理的反応に基づく学術的知見および測定時点のデータに基づくものであり、特定の効果や医学的・治療的効能を保証するものではありません。空間体験の快適性やリラックス効果には個人差があります。また、当スタジオは本ウェブサイトの情報に関して、その正確性や完全性を保証するものではなく、利用により生じた直接的または間接的な損害について一切の責任を負いません。
        </p>

        <p className="heading_1">
          <strong>6. 規約の変更</strong>
        </p>
        <p className="body_text">
          当スタジオは、独自の判断により、いつでも本規約を変更する権利を留保します。変更後の規約は、本ウェブサイトに掲載された時点から効力を生じるものとします。最新の規約を定期的にご確認ください。
        </p>

        <p className="heading_1">
          <strong>7. 準拠法および管轄裁判所</strong>
        </p>
        <p className="body_text">
          本規約の解釈および適用は日本法に準拠するものとします。本サービスまたは本規約に関して生じる一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </p>

        <p className="heading_1">
          <strong>8. お問い合わせ窓口</strong>
        </p>
        <p className="body_text">
          本規約に関するご質問や苦情がございましたら、下記までご連絡ください。
          <br />
          <strong>
            <ProtectedEmail
              user="info"
              domain="myarchitecthelp.com"
              className="link"
            />
          </strong>
        </p>
      </div>
    )
  }

  return (
    <div
      className="legal-document"
      {...props}
      style={{
        maxWidth: 800,
        margin: "auto",
      }}
    >
      <p className="title">
        <strong>TERMS AND CONDITIONS</strong>
      </p>

      <p className="subtitle">
        <strong>Last updated: June 4, 2026</strong>
      </p>

      <p className="body_text">
        These Terms and Conditions (&quot;Terms&quot;) govern your access to and
        use of the website and services provided by Atelier α
        (&quot;Studio&quot;, &quot;we&quot;, &quot;us&quot;, or
        &quot;our&quot;). By accessing or using our Services, you agree to be
        bound by these Terms. If you do not agree with all of these Terms, you
        are prohibited from using the Services and must discontinue use
        immediately.
      </p>

      <p className="heading_1">
        <strong>1. Services Provided</strong>
      </p>
      <p className="body_text">
        Atelier α provides neuro-architecture research, EEG-based spatial
        diagnosis, eye-tracking cognitive analyses, spatial design optimization
        proposals, corporate workshops, and related design consulting services.
      </p>

      <p className="heading_1">
        <strong>2. Intellectual Property Rights</strong>
      </p>
      <p className="body_text">
        All content on the Services (including but not limited to text,
        graphics, logos, design concepts, source code, proprietary EEG analysis
        models, and the &quot;Embodied Attention&quot; framework) is the
        property of Atelier α or its licensors and is protected by copyright and
        other intellectual property laws. No part of our Services or designs may
        be reproduced, modified, distributed, or commercialized without our
        express prior written consent.
      </p>

      <p className="heading_1">
        <strong>3. Client Cooperation & Data Consent</strong>
      </p>
      <p className="body_text">
        For the execution of spatial diagnoses involving brainwave measurements,
        cooperation and certain inputs from the participants/clients are
        required. Resulting physiological data is processed in a strictly
        anonymized manner and may be used for design optimization and academic
        research to improve our spatial tuning algorithms.
      </p>

      <p className="heading_1">
        <strong>4. Prohibited Activities</strong>
      </p>
      <p className="body_text">In using the Services, you agree not to:</p>
      <ul>
        <li className="body_text">
          Violate any applicable local, national, or international laws.
        </li>
        <li className="body_text">
          Infringe upon the intellectual property or privacy rights of Atelier α
          or others.
        </li>
        <li className="body_text">
          Use automated systems (crawlers, scrapers, bots) to extract data from
          our website.
        </li>
        <li className="body_text">
          Interfere with or disrupt the security and operation of the website.
        </li>
      </ul>

      <p className="heading_1">
        <strong>5. Disclaimer & Limitation of Liability</strong>
      </p>
      <p className="body_text">
        Our EEG-based spatial optimization and consulting services are based on
        current scientific research and individual physiological measurements.
        They do not constitute medical advice or guarantee therapeutic effects.
        Cognitive responses to space vary naturally by individual. Atelier α
        does not guarantee the complete accuracy or completeness of the
        informational materials on this site and shall not be liable for any
        direct, indirect, or consequential damages resulting from the use of
        this site or our spatial consultations.
      </p>

      <p className="heading_1">
        <strong>6. Modifications to Terms</strong>
      </p>
      <p className="body_text">
        We reserve the right, in our sole discretion, to update or modify these
        Terms at any time. Changes become effective immediately upon posting on
        this website. Please review these Terms periodically to stay informed.
      </p>

      <p className="heading_1">
        <strong>7. Governing Law & Jurisdiction</strong>
      </p>
      <p className="body_text">
        These Terms shall be governed by and construed in accordance with the
        laws of Japan. Any disputes arising from or relating to these Terms or
        our Services shall be subject to the exclusive jurisdiction of the Tokyo
        District Court in Japan.
      </p>

      <p className="heading_1">
        <strong>8. Contact Us</strong>
      </p>
      <p className="body_text">
        To resolve a complaint or to receive further information regarding use
        of the Services, please contact us at:
        <br />
        <strong>
          <ProtectedEmail
            user="info"
            domain="myarchitecthelp.com"
            className="link"
          />
        </strong>
      </p>
    </div>
  )
}

export default atomize(TermsAndConditions)({
  name: "TermsAndConditions",
  effects: {
    hover: ":hover",
  },
  normalize: true,
  mixins: true,
  description: {
    en: "TermsAndConditions Component",
  },
  propInfo: {},
})
